import { render, staticRenderFns } from "./TrueFalseIcon.vue?vue&type=template&id=55890682"
import script from "./TrueFalseIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrueFalseIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports